import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { warn } from '../../utils/error-logging';
const DEFAULT_CONFIG = {
    imageQuality: 'highQuality95',
};
const ConfigContext = createContext(undefined);
export const useConfig = () => {
    const config = useContext(ConfigContext);
    if (!config) {
        throw new Error('Content Component Library: No config found. `useConfig` must be called from within a ContentComponentLibraryProvider that has a required config passed to it.');
    }
    return config;
};
export const ContentComponentLibraryProvider = ({ children, config, }) => {
    if (!config) {
        warn('Content Component Library: A config must be provided.');
    }
    const mergedConfig = config
        ? Object.assign(Object.assign({}, DEFAULT_CONFIG), config) : undefined;
    return _jsx(ConfigContext.Provider, { value: mergedConfig, children: children });
};
//# sourceMappingURL=index.js.map